/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerContextQueryResponse, VistaControllerContextPathParams, VistaControllerContext400, VistaControllerContext401, VistaControllerContext403, VistaControllerContext404 } from "../../models/changeOrdersController/VistaControllerContext";

function getVistaControllerContextUrl(id: VistaControllerContextPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/potential-change-orders/${id}/vista` as const }  
  return res
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista}
 */
export async function vistaControllerContext(id: VistaControllerContextPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<VistaControllerContextQueryResponse, ResponseErrorConfig<VistaControllerContext400 | VistaControllerContext401 | VistaControllerContext403 | VistaControllerContext404>, unknown>({ method : "GET", url : getVistaControllerContextUrl(id).url.toString(), ... requestConfig })  
  return res.data
}